<template>
  <div>
    <div v-if="downloadables.length > 0">
      <div v-if="downloadables[0].evType === 1" class="col text-center pt-5">
        <h2 class="my-5">
          <b>Download processed files</b>
        </h2>
        <img class="download-icn" src="../assets/images/zip.svg" />
        <div class="mt-3">
          <strong> {{ downloadables[0].filename }} </strong>
        </div>
        <p>Download links will be valid for the next 2 hours</p>
        <div class="download-url-ctr p-3 rounded">
          {{ downloadables[0].downloadURL }}
        </div>
        <button class="btn next-btn m-4 px-3 py-2" @click="downloadHandler">
          <i class="fa fa-download" />&nbsp Download
        </button>
      </div>
      <div v-if="downloadables[0].evType === 2" class="col text-center pt-5">
        <h2 class="my-5">
          <b>Download EEO token</b>
        </h2>
        <img class="download-icn" src="../assets/images/certificate.svg" />
        <div v-if="success === true">
          <div class="hash-container border rounded mt-2">
            <strong>
              Timestamp:
              <span class="txt-blue">{{ this.downloadables[0].timestamp }}</span>
            </strong>
          </div>
          <div class="hash-container border rounded mt-2">
            <strong>
              Signature:
              <span class="txt-blue">{{ this.downloadables[0].signature }}</span>
            </strong>
          </div>
          <button class="btn next-btn m-4 px-3 py-2" @click="downloadHandler">
            <i class="fa fa-download" />&nbsp Download
          </button>
        </div>
      </div>
    </div>
    <a v-if="showReload === true" title="Start Over" @click="reload" id="startover-button"> <i
        class="fa fa-redo-alt"></i> </a>
  </div>
</template>
<script>
import cfg from "../config"
import { saveAs } from "file-saver"
import truncate from "../functions/truncate"

export default {
  name: "Finish",
  props: {
    OTUItems: Array,
  },
  data() {
    return {
      downloadables: [],
      success: false,
      showReload: false
    }
  },
  methods: {
    fetchProcessed() {
      this.OTUItems.map((item, index) => {
        var evPath = item.evType === 2 ? "otu-signature" : "otu-capture"
        var url = `${cfg.dataAPIURL}/data/${evPath}/${item.id}`
        this.axios.get(url).then((response) => {
          if (item.evType === 1) {
            this.downloadables.push({
              ind: index,
              filename: item.filename,
              downloadURL: response.data.downloadUrl,
              evType: item.evType,
            })
          } else {
            if ('signature' in response.data) {
              this.downloadables.push({
                ind: index,
                filename: item.filename,
                signature: response.data.signature,
                evType: item.evType,
                timestamp: response.data.timestamp,
              })
              this.success = true
            }
          }
        })
      })
    },
    downloadHandler() {
      var file = null
      var filename, filenameExt, filenameNoExt = null
      if (this.downloadables[0].evType === 2) {
        var txtString = btoa(
          JSON.stringify({
            signature: this.downloadables[0].signature,
            timestamp: this.downloadables[0].timestamp,
          })
        )
        file = new Blob([txtString], {
          type: "text/plain;charset=utf-8;",
        })
        filenameExt = this.downloadables[0].filename
        filenameNoExt = filenameExt.substring(0, filenameExt.lastIndexOf('.')) || filenameExt
        filename = `${filenameNoExt}.sig`
      } else {
        file = this.downloadables[0].downloadURL
        filename = `${this.downloadables[0].filename}.zip`
      }
      saveAs(file, filename)
      localStorage.removeItem('OTUbackup')
      this.showReload = true
    },
    reload() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      this.showReload = false
    },
    truncate,
  },
  mounted() {
    this.fetchProcessed()
  },
}
</script>
<style scoped>
@media only screen and (max-width: 600px) {
#startover-button {
  text-align: center;
  width: 35px !important;
  height: 35px !important;
  right: 10px !important;
}

#startover-button i {
  margin-top: 4px;
  font-size: 25px !important;
}
}
td {
  max-width: 200px;
  word-break: break-all;
  text-align: left;
}

.download-icn {
  width: 100px;
}

.download-url-ctr {
  word-break: break-all;
  border: 2px solid #10a2e663;
  background-color: #10a2e613;
  overflow-y: hidden;
  white-space: nowrap;
  scrollbar-width: none;
}

.download-url-ctr::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.txt-blue {
  color: #10a2e6;
}

.hash-container {
  padding: 10px;
  font-size: 13px;
  word-break: break-all;
  overflow: hidden;
}

#startover-button {
  display: inline-block;
  background-color: var(--primary-orange-yellow);
  width: 50px;
  height: 50px;
  border-radius: 4px;
  position: fixed;
  bottom: 30px;
  right: 30px;
  transition: background-color .3s,
    opacity .5s, visibility .5s;
  z-index: 1000;
  text-align: center;
}

#startover-button i {
  font-size: 37px;
  color: #069;
  margin-top: 5px;
}

#startover-button:hover {
  cursor: pointer;
  background-color: darkorange;
}

#startover-button:active {
  background-color: #555;
}
</style>


// WEBPACK FOOTER //
// src/components/Finish.vue